var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.90278C7.48863 1.34917 8.20354 1 9 1C10.4728 1 11.6667 2.19391 11.6667 3.66667C11.6667 5.13943 10.4728 6.33333 9 6.33333C8.20354 6.33333 7.48863 5.98416 7 5.43055M9 13H1V12.3333C1 10.1242 2.79086 8.33333 5 8.33333C7.20914 8.33333 9 10.1242 9 12.3333V13ZM9 13H13V12.3333C13 10.1242 11.2091 8.33333 9 8.33333C8.27143 8.33333 7.58835 8.52812 7 8.86846M7.66667 3.66667C7.66667 5.13943 6.47276 6.33333 5 6.33333C3.52724 6.33333 2.33333 5.13943 2.33333 3.66667C2.33333 2.19391 3.52724 1 5 1C6.47276 1 7.66667 2.19391 7.66667 3.66667Z",
    stroke: "#A1A4A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllUsers);
export default __webpack_public_path__ + "static/media/AllUsers.7c611268c021b83a4176c2e67e1acf0e.svg";
export { ForwardRef as ReactComponent };